import { withBemMod } from '@bem-react/core';
import { cnPopup } from '../Popup';
import './Popup_nonvisual.css';
/**
 * Модификатор который убирает стили попапа влияющие на визуальный стиль.
 * @param {IPopupNonvisualProps} props
 */
export var withNonvisual = withBemMod(cnPopup(), { nonvisual: true });
